<template>
    <div>
        <sammio-actions mobileNavText="usein_haetut" @drawer="setDrawerStatus" :isMobile="getMobileStatus" :status="getDrawerStatus"></sammio-actions>
        <div class="container">
            <div class="row">
                <aside v-if="!getMobileStatus" class="col-md-4 bg-white pt-3" ref="sticky__wrapper" id="sammio__element--aside">
                    <div class="sammio__intersect--marker" v-intersect="onIntersect"></div>
                    <div ref="stickyContent" :class="!isIntersecting ? '' : 'v-sticky--element'">
                        <div :class="isIntersecting ? 'sammio__container--scrollable' : '' " :style="isIntersecting ? 'width:'+ (this.stickyWidth - 12) + 'px' : '' ">
                            <h4 class="sammio-panels__title--category pl-3">{{$t('sammio.frequentsearches.title')}}</h4>
                            <v-list
                              class="sammio-list--treeview"
                            >
                                <template v-for="(frequentSearch, index) in frequentSearches">
                                    <v-list-item :key="'-fs-list-' + index">
                                        <v-list-item-content>
                                            <div 
                                                class="sammio-list__item--main"
                                                :class="getActiveUrl() === frequentSearch.url ? 'active' : ''"
                                                :aria-current="getActiveUrl() === frequentSearch.url ? 'location' : 'false'"
                                                @click="loadFrequentSearchCards(frequentSearch)"
                                                @keydown.enter="loadFrequentSearchCards(frequentSearch)"
                                                v-bind:tabindex="[frequentSearch.url !== '' ? 0 : -1]"
                                            >
                                                {{frequentSearch.title}}
                                            </div>
                                            <v-list v-if="hasChildren(frequentSearch.children)" class="children">
                                                <template v-for="(frequentSearchChild, indexChild) in frequentSearch.children">
                                                    <v-list-item :key="'-fs-list-child-' + indexChild">
                                                        <v-list-item-content>
                                                            <div class="sammio-list__item--children"
                                                                :class="getActiveUrl() === frequentSearchChild.url ? 'active' : ''"
                                                                :aria-current="getActiveUrl() === frequentSearchChild.url ? 'location' : 'false'"
                                                                @click="loadFrequentSearchCards(frequentSearchChild)"
                                                                @keydown.enter="loadFrequentSearchCards(frequentSearchChild)"
                                                                v-bind:tabindex="[frequentSearchChild.url !== '' ? 0 : -1]"
                                                            >
                                                                {{frequentSearchChild.title}}
                                                            </div>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </template>
                                            </v-list>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-list>
                        </div>
                    </div>
                </aside>

                <section :class="getClassNames" v-if="!error" ref="article" id="sammio__element--main">
                    <article>
                        <div>
                            <h1>{{title}}</h1>
                            <v-container>
                                <v-row v-for="(card, index) in selectedSearches" :key="card.key + '-' + card.title">
                                    <sammio-card
                                            :id="`card-${card.statuteIndex}-${card.chapterIndex}-${card.sectionIndex}-${card.subsectionIndex}`"
                                            :cardProps="card"
                                            :index="index"
                                            css-class="sammio-card bg-white p-3 mb-4 w-100"
                                            :key="`card-${card.statuteIndex}-${card.chapterIndex}-${card.sectionIndex}-${card.subsectionIndex}-${card.justificationVisible}-${card.guidanceVisible}`"
                                            v-on:click-subsection-link="onClickSubsectionLink($event, index)"
                                    >
                                    </sammio-card>
                                </v-row>
                            </v-container>
                        </div>
                    </article>
                </section>
                <section class="col-md-8" v-else>
                    <sammio-errors
                            target="frequentSearches"
                            :data="this.getErrors.data"
                    ></sammio-errors>
                </section>
            </div>
        </div>

        <v-navigation-drawer
                v-model="showMobileDrawer"
                app
                temporary
                width="90vw"
                v-if="getMobileStatus"
        >
            <v-btn class="btn-link border-0 p-0 m-0 text-black sammio__button--close_panel" @click="showMobileDrawer = false"><x-icon size="1.75x" ></x-icon><span class="sr-only">{{$t('sammio.close')}}</span></v-btn>
            <h4 class="sammio-panels__title p">{{$t('sammio.frequentsearches.title')}}</h4>
            <v-list>
                <template v-for="(frequentSearch, index) in frequentSearches">
                    <v-list-item :key="'mob-fs-list-' + index">
                        <v-list-item-content>
                            <span @click="loadFrequentSearchCards(frequentSearch, index)">
                                    {{frequentSearch.title}}
                            </span>

                            <v-list class="children">
                                <template v-for="(frequentSearchChild, childIndex) in frequentSearch.children">
                                    <v-list-item :key="'mob-fs-list-child-' + childIndex">
                                        <v-list-item-content>
                                            <span @click="loadFrequentSearchCards(frequentSearchChild, childIndex)">
                                                {{frequentSearchChild.title}}
                                            </span>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-list>
                        </v-list-item-content>
                    </v-list-item>
                </template>
            </v-list>
        </v-navigation-drawer>
    </div>
</template>

<script>
    import SammioActions from "./SammioActions"
    import SammioErrors from "./SammioErrors"
    import SammioCard from "./SammioCard"
    import * as http from "../store/http"
    import {i18n} from "../translations/i18n"
    import {MenuIcon, XIcon} from 'vue-feather-icons'
    import layout from "../shared/layout-mixin";
    import {mapGetters} from 'vuex'
    import {fetchSubsection, getCardsFromResponse, getInt, isSameCard} from "../store/helpers";

    export default {
        name: "SammioFrequentSearches",
        data() {
            return {
                frequentSearches: [],
                title: '',
                error: false,
                initialized: false,
                selectedSearches: [],
                activeSearch: {}
            }
        },
        components: {
            SammioActions,
            SammioErrors,
            SammioCard,
            XIcon,
            MenuIcon,
        },
        mixins: [layout],
        computed: {
            ...mapGetters([
                'getErrors'
            ]),
            locale() {
                return i18n.locale
            }
        },
        mounted() {
            this.getFrequentSearches()
        },
        methods: {
            initialize() {
                this.initialized = false
                this.getFrequentSearches()
            },
            getFrequentSearches() {
                http.get('/get-frequent-searches', this.$store.state.portletId, { lang: this.locale })
                    .then(response => {
                        this.frequentSearches = response.data.frequentSearches
                        if (!this.initialized && (this.frequentSearches.length > 0)) {
                            this.loadFrequentSearchCards(this.frequentSearches[0])
                            this.title = this.frequentSearches[0].title
                            this.activeSearch = this.frequentSearches[0]
                            this.initialized = true
                        }
                    })
                    .catch(error => {
                        this.error = true
                        this.$store.dispatch('setErrorMessages', { hasErrors: true, data: { type: 'frequentSearches', code: '', text: i18n.t('sammio.errors.common_error') } })
                    })
            },
            loadFrequentSearchCards(frequentSearch) {
                const urlMatch = frequentSearch.url.match(/.*\/(\w+)(\\?.*|)$/)
                let shortUrl = ''
                if ((urlMatch !== null) && (urlMatch.length > 1)) {
                    shortUrl = urlMatch[1]
                }
                if ((shortUrl !== null) && (shortUrl !== '')) {
                    this.title = frequentSearch.title
                    this.activeSearch = frequentSearch
                    http.get('/load-bookmarks', this.$store.state.portletId, { shortUrl: shortUrl, lang: this.locale })
                        .then(response => {
                            this.selectedSearches = getCardsFromResponse(response.data.subsections)
                        })
                        .catch(error => {
                            this.error = true
                            this.$store.dispatch('setErrorMessages', { hasErrors: true, data: { type: 'frequentSearches', code: '', text: i18n.t('sammio.errors.common_error') } })
                        })
                }
            },
            typesetMathJax() {
                this.$nextTick(function() {
                    MathJax.typeset(['.sammio-card'])
                })
            },
            getSubsectionCallback(payload) {
                let index = payload.index
                if ((typeof payload.index === 'number') && (payload.type !== 'act')) {
                    index = payload.index + 1
                }

                const isAlreadyVisible = this.selectedSearches.filter(card => isSameCard(card, payload.card)).length > 0
                if (!isAlreadyVisible) {
                    if (typeof index === 'number') {
                        this.selectedSearches.splice(index, 0, payload.card)
                    } else {
                        this.selectedSearches.push(bookmark);
                    }
                }
            },
            onClickSubsectionLink(eventPayload, index) {
                fetchSubsection(this.$store, eventPayload.indices, index, this, this.getSubsectionCallback)
            },
            hasChildren(children) {
                // Check if any of children have title or url data
                for (const [key, value] of Object.entries(children)) {
                  if (value.title || value.url) return true;
                }
                return false;
            },
            getActiveUrl() {
                // Check if url is set, preventing empty elements being marked as active
                if (this.activeSearch.url) {
                    return this.activeSearch.url;
                } else {
                    return false;
                }
            }
        },
        beforeRouteLeave(to, from, next) {
            if (to.name === 'search_card') {
                let regexpPath = /\/(?<statuteIndex>\w+)\/(?<chapterIndex>\w+)\/(?<sectionIndex>\w+)\/?(?<subsectionIndex>\w+)/g
                let match = regexpPath.exec(to.path)
                if (match !== null) {
                    let cardIndices = {
                        statuteIndex: getInt(match.groups.statuteIndex),
                        chapterIndex: getInt(match.groups.chapterIndex),
                        sectionIndex: getInt(match.groups.sectionIndex),
                        subsectionIndex: match.groups.subsectionIndex ? getInt(match.groups.subsectionIndex) : 1
                    }
                    fetchSubsection(this.$store, cardIndices, this.selectedSearches.length, this, this.getSubsectionCallback)
                } else {
                    next()
                }
            } else {
                next()
            }
        },
        watch: {
            $route (to, from) {
                if (from && (from.name !== to.name) && (to.name.startsWith('frequentsearches'))) { // coming from another view
                    this.initialize()
                }
            },
            selectedSearches(value) {
                this.typesetMathJax()
            },
            locale() {
                if (this.$router.currentRoute.name.startsWith('frequentsearch')) {
                    this.initialize()
                }
            }
        }

    }
</script>

<style lang="scss" scoped>
    .sticky__container {
        position: relative;
    }
    .sammio__intersect--marker {
        display: block;
        width: 1px;
        height: 1px;
        margin: 0;
        padding: 0;
        opacity: 0;
        visibility: hidden;
    }

    /* NAVIGATION DRAWER */
    .v-navigation-drawer {
        -webkit-overflow-scrolling: touch;
        display: flex;
        flex-direction: column;
        left: 0;
        max-width: 100%;
        overflow: hidden;
        pointer-events: auto;
        top: 0;
        transition-duration: .2s;
        transition-timing-function: cubic-bezier(.4,0,.2,1);
        will-change: transform;
        transition-property: transform,visibility,width;


    }

    .theme--light.v-navigation-drawer {
        background-color: #fff;
    }

    .v-navigation-drawer--temporary {
        z-index: 11;
    }

    .v-navigation-drawer--fixed {
        position: fixed;
        background-color: white;
    }

    .v-navigation-drawer__content {
        height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
    }

    .v-navigation-drawer__border {
        position: absolute;
        right: 0;
        top: 0;
        height: 100%;
        width: 1px;
    }

    .v-navigation-drawer--is-mobile:not(.v-navigation-drawer--close), .v-navigation-drawer--temporary:not(.v-navigation-drawer--close) {
        box-shadow: 0 8px 10px -5px rgba(0,0,0,.2), 0 16px 24px 2px rgba(0,0,0,.14), 0 6px 30px 5px rgba(0,0,0,.12);
    }

    .theme--light.v-navigation-drawer:not(.v-navigation-drawer--floating) .v-navigation-drawer__border {
        background-color: rgba(0,0,0,.12);
    }
    .v-sticky--element {
        position: fixed;
        top: 1rem;
    }
    .sammio__container--scrollable {
        position: relative;
        height: 97vh;
        overflow-y: scroll;
    }

    .children .v-list-item__content {
        padding-left: 1.875rem;
    }


</style>
